import React, { useState } from "react";
import { Link } from "react-router-dom";
import brand from "../brand";
import "./style.css";

const Footer = () => {
  const [visible, setVisible] = useState(true);

  return (
    <>
      <footer className={`footer-container ${visible ? "" : "hidden"}`}>
        <button className="close-btn" onClick={() => setVisible(false)} aria-label="Hide footer">
          &times;
        </button>
        <div className="container footer-inner">
          <div>
            <strong>{brand.name}</strong>
            <p>
              Results are provided for reference and informational purposes only.
              Please verify important claims with official published sources.
            </p>
          </div>
          <nav aria-label="Footer links">
            <Link to="/contact-us">Contact</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms-and-conditions">Terms</Link>
            <Link to="/about-us">About</Link>
          </nav>
        </div>
      </footer>

      {!visible && (
        <button className="reopen-btn" onClick={() => setVisible(true)} title="Show footer">
          Show policy links
        </button>
      )}
    </>
  );
};

export default Footer;
